import axios from "axios";
import { cacheMediaResponse } from "@/lib/mediaUrls";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.mediaOwnerToken = token || "";
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => { cacheMediaResponse(r.data, r.config?.mediaOwnerToken); return r; },
  (err) => {
    const isLoginRequest = (err.config?.url || "").includes("/auth/login");
    if (err.response?.status === 401 && !isLoginRequest && !window.location.pathname.includes("/widget")) {
      localStorage.removeItem("token");
      localStorage.removeItem("currentUser");
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(err);
  }
);

export const publicApi = axios.create({ baseURL: API });

export function apiError(e) {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e.message || "Terjadi kesalahan";
}

export default api;
